import {
  DashboardAdminPermissions,
  DashboardUserPermissions,
  DataDictionaryFeaturePermissions,
  FileTrackerAdminPermissions,
  FileTrackerUserPermissions,
  ProgramUserPermissions,
  ProgramAdminPermissions,
  TemplatesAdminPermissions,
  TemplatesUserPermissions,
} from './common';

const QuestAdminFeaturePermissions = {
  ...DataDictionaryFeaturePermissions,
  MayViewAdminPage: 'Q-MVAP',
};

const QuestClientUserPermissions = {
  ...DashboardUserPermissions,
  ...FileTrackerUserPermissions,
  ...ProgramUserPermissions,
  ...TemplatesUserPermissions,
};

const QuestClientAdminPermissions = {
  ...QuestClientUserPermissions,
  ...DashboardAdminPermissions,
  ...FileTrackerAdminPermissions,
  ...ProgramAdminPermissions,
  ...TemplatesAdminPermissions,
};

const QuestAdminPermissions = {
  ...QuestClientAdminPermissions,
  ...QuestAdminFeaturePermissions,
};

export const questRoles = {
  Admin: {
    name: 'Quest-Admin',
    permissions: QuestAdminPermissions,
  },
  ClientAdmin: {
    name: 'Quest-Client-Admin',
    permissions: QuestClientAdminPermissions,
  },
  ClientUser: {
    name: 'Quest-Client-User',
    permissions: QuestClientUserPermissions,
  },
} as const;
